webpackJsonp([5],{

/***/ 2:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = {
	    __widthMobile: 1000,
	    __widthMobileTablet: 1000,
	    __widthMobileTabletMiddle: 850,
	    __widthMobileSmall: 540,
	    __isMobile: false,
	    __isMobileTablet: false,
	    __isMobileTabletMiddle: false,
	    __isMobileSmall: false,
	    __animationSpeed: 350,
	
	    initElements: function initElements(el) {
	        var element = $(el ? el : 'body');
	        var that = this;
	
	        $(window).on('resize', function () {
	            that.onResize();
	        });
	
	        $.widget('app.selectmenu', $.ui.selectmenu, {
	            _drawButton: function _drawButton() {
	                this._super();
	                var selected = element.find('[selected]').length,
	                    placeholder = this.options.placeholder;
	
	                if (!selected && placeholder) {
	                    this.buttonItem.text(placeholder).addClass('placeholder');
	                } else {
	                    this.buttonItem.removeClass('placeholder');
	                }
	            }
	        });
	
	        $.datepicker.regional['ru'] = {
	            closeText: 'Закрыть',
	            prevText: '&#x3c;Пред',
	            nextText: 'След&#x3e;',
	            currentText: 'Сегодня',
	            monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
	            monthNamesShort: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
	            dayNames: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота'],
	            dayNamesShort: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'сбт'],
	            dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
	            weekHeader: 'Нед',
	            dateFormat: 'dd.mm.yy',
	            firstDay: 1,
	            isRTL: false,
	            showMonthAfterYear: false,
	            yearSuffix: ''
	        };
	        $.datepicker.setDefaults($.datepicker.regional['ru']);
	
	        element.find('select').each(function (i, select) {
	            // editable select
	            if (typeof $(select).attr('editable') != 'undefined' && $(select).attr('editable') !== 'false') {
	                $(select).editableSelect({
	                    effects: 'fade',
	                    source: $(select).attr('source') ? $(select).attr('source') : false
	                }).on('change.editable-select', function (e) {
	                    var $holder = $(e.target).closest('.input-holder');
	                    if ($holder.find('.es-input').val()) {
	                        $(e.target).closest('.input-holder').addClass('focused');
	                    } else {
	                        $(e.target).closest('.input-holder').removeClass('focused');
	                    }
	                });
	
	                // simple select
	            } else {
	                if ($(select).offset().left + 370 > $(window).width()) {
	                    $(select).attr('data-pos', 'right');
	                }
	
	                var offset = $(select).attr('data-offset');
	                if ($(select).attr('data-pos') == 'right') {
	                    var data = {
	                        position: { my: "right" + (offset ? "+" + offset : "") + " top-2", at: "right bottom" }
	                    };
	                } else {
	                    var data = {
	                        position: { my: "left" + (offset ? "+" + offset : "") + " top-2" }
	                    };
	                }
	                if (typeof $(select).attr('placeholder') != 'undefined') {
	                    data['placeholder'] = $(select).attr('placeholder');
	                }
	                data['change'] = function (e, ui) {
	                    $(ui.item.element).closest('.input-holder').addClass('focused');
	                };
	                data['appendTo'] = $(select).parent();
	                $(select).selectmenu(data);
	                if (typeof $(select).attr('placeholder') != 'undefined') {
	                    $(select).prepend('<option value="" disabled selected>' + data['placeholder'] + '</option>');
	                }
	            }
	        });
	
	        element.find('.js-date').each(function (index, input) {
	            var datepicker_options = {
	                inline: true,
	                language: 'ru',
	                changeYear: true,
	                changeMonth: true,
	                showOtherMonths: true
	            };
	            var minYear = $(input).attr('data-min-year');
	            if (minYear) datepicker_options.minDate = '01.01.' + minYear;else minYear = 'c-10';
	            var maxYear = $(input).attr('data-max-year');
	            if (maxYear) datepicker_options.maxDate = '01.01.' + maxYear;else maxYear = 'c+10';
	            var defaultDate = $(input).attr('data-default-date');
	            if (defaultDate) datepicker_options.defaultDate = defaultDate;
	            datepicker_options.yearRange = [minYear, maxYear].join(':');
	
	            $(input).attr('type', 'text').datepicker(datepicker_options).addClass('date').val($(input).attr('value')).after('<i></i>');
	            $(input).next('i').click(function () {
	                $(this).prev('input').datepicker('show');
	                //initElements($('#ui-datepicker-div'));
	            });
	        });
	
	        element.find('.js-datetime').each(function (index, input) {
	            var datepicker_options = {
	                inline: true,
	                language: 'ru',
	                changeYear: true,
	                changeMonth: true,
	                showOtherMonths: true,
	                currentText: 'Текущее время',
	                closeText: 'Готово',
	                timeText: 'Время',
	                hourText: 'Часы',
	                minuteText: 'Минуты'
	            };
	            var minYear = $(input).attr('data-min-year');
	            if (minYear) datepicker_options.minDate = '01.01.' + minYear;else minYear = 'c-10';
	            var maxYear = $(input).attr('data-max-year');
	            if (maxYear) datepicker_options.maxDate = '01.01.' + maxYear;else maxYear = 'c+10';
	            var defaultDate = $(input).attr('data-default-date');
	            if (defaultDate) datepicker_options.defaultDate = defaultDate;
	            datepicker_options.yearRange = [minYear, maxYear].join(':');
	
	            $(input).attr('type', 'text').datetimepicker(datepicker_options).addClass('date').val($(input).attr('value')).after('<i></i>');
	            $(input).next('i').click(function () {
	                $(this).prev('input').datepicker('show');
	                //initElements($('#ui-datepicker-div'));
	            });
	        });
	
	        element.find('input[type="checkbox"], input[type="radio"]').checkboxradio();
	
	        element.find('.file-upload').each(function (index, block) {
	            $(block).find('.label').click(function (e) {
	                e.preventDefault();
	            });
	        });
	
	        element.find('.modal-close, .close-btn, .modal .js-cancel').click(function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	
	            if (element.find('.modal-wrapper:visible').length > 1) {
	                element.find('.modal-wrapper[data-transparent]').stop().animate({ 'opacity': 1 }, that.__animationSpeed);
	                that.hideModal(this, true);
	            } else {
	                that.hideModal(this, false);
	            }
	        });
	
	        element.find('.tabs, .js-tabs').lightTabs();
	
	        element.find('.js-scroll').each(function (index, block) {
	            if (!$(block).attr('data-on-demand')) {
	                that.scrollInit(block);
	            }
	        });
	
	        $('body').mouseup(function (e) {
	            /*
	            if ($('.modal-fadeout').css('display') == 'block' && !$('html').hasClass('html-mobile-opened')) {
	                if (!$(e.target).closest('.contents').length && !$(e.target).closest('.ui-selectmenu-menu').length && !$(e.target).closest('.ui-datepicker').length) {
	                    that.hideModal();
	                }
	            }
	            */
	            if ($('html').hasClass('html-mobile-opened')) {
	                if (!$(e.target).closest('.menu-holder').length) {
	                    $('nav .close').click();
	                }
	            }
	        }).keypress(function (e) {
	            if (!e) e = window.event;
	            var key = e.keyCode || e.which;
	
	            if ($('.modal-fadeout').css('display') == 'block') {
	                if (key == 27) {
	                    that.hideModal();
	                }
	            }
	            if ($('html').hasClass('html-mobile-opened')) {
	                if (key == 27) {
	                    $('nav .close').click();
	                }
	            }
	        });
	
	        element.find('.input-holder input').keydown(function () {
	            if ($(this).val()) {
	                $(this).parent('.input-holder').addClass('focused');
	            }
	        }).keyup(function () {
	            if (!$(this).val()) {
	                $(this).parent('.input-holder').removeClass('focused');
	            }
	        }).focusout(function () {
	            if (!$(this).val()) {
	                $(this).parent('.input-holder').removeClass('focused');
	            }
	        }).each(function (i, item) {
	            if ($(item).val()) {
	                $(item).parent('.input-holder').addClass('focused');
	            }
	        });
	
	        element.find('textarea.js-autoheight').each(function (i, textarea) {
	            if (!$(textarea).data('autoheight-inited')) {
	                $(textarea).attr('rows', 1);
	                $(textarea).on('input', function () {
	                    $(this).css('height', 'auto');
	                    $(this).css('height', $(this)[0].scrollHeight + 'px');
	                });
	                if ($(textarea).css('display') != 'none') $(textarea).trigger('input');
	                $(textarea).data('autoheight-inited', true);
	            }
	        });
	
	        this.fadeoutInit();
	    },
	
	    onResize: function onResize() {
	        this.__isMobile = $(window).width() <= this.__widthMobile;
	        this.__isMobileTablet = $(window).width() <= this.__widthMobileTablet;
	        this.__isMobileTabletMiddle = $(window).width() <= this.__widthMobileTabletMiddle;
	
	        if ($('#doc-list').length) {
	            if (!this.__isMobileTabletMiddle) {
	                docListPos();
	            }
	        }
	
	        if (this.__isMobileTabletMiddle) {
	            $('#bl-account .logout').appendTo('header .menu-holder nav');
	        } else {
	            $('header .menu-holder nav>.logout').appendTo('#bl-account');
	        }
	
	        this.fadeoutInit();
	    },
	
	    parseUrl: function parseUrl(url) {
	        if (typeof url == 'undefined') url = window.location.toString();
	        var a = document.createElement('a');
	        a.href = url;
	
	        var pathname = a.pathname.match(/^\/?(\w+)/i);
	
	        var parser = {
	            'protocol': a.protocol,
	            'hostname': a.hostname,
	            'port': a.port,
	            'pathname': a.pathname,
	            'search': a.search,
	            'hash': a.hash,
	            'host': a.host,
	            'page': pathname ? pathname[1] : ''
	        };
	
	        return parser;
	    },
	
	    showModal: function showModal(modal_id, dontHideOthers) {
	        var $modal = $('#' + modal_id);
	        var that = this;
	
	        if (typeof dontHideOthers == 'undefined' || !dontHideOthers) $('.modal-wrapper:visible').not($modal).attr('data-transparent', true).stop().animate({ 'opacity': 0 }, that.__animationSpeed);
	
	        var display = this.__isMobileTablet ? 'block' : 'table';
	        if (modal_id == 'modal-geo' && this.__isMobileTablet && !this.__isMobileTabletMiddle) {
	            display = 'table';
	        }
	
	        $('.modal-fadeout').stop().fadeIn(300);
	        $modal.stop().fadeIn(450).css({
	            'display': display,
	            'top': $(window).scrollTop()
	        });
	
	        var oversize = $(window).height() < $modal.find('.contents').outerHeight(true);
	
	        if ($modal.attr('data-long') || oversize) {
	            $('html').addClass('html-modal-long');
	
	            if (oversize && this.__isMobile) {
	                var modalHeight = $modal.outerHeight();
	                $('#layout').data('scrollTop', $(window).scrollTop()).addClass('js-modal-overflow').height(modalHeight);
	                $modal.css('top', 0);
	                $('html,body').scrollTop(0);
	            }
	        } else {
	            $('html').addClass('html-modal');
	        }
	
	        $modal.find('.js-scroll').each(function (index, block) {
	            that.scrollInit(block);
	        });
	    },
	
	    hideModal: function hideModal(sender, onlyModal) {
	        var $modal = sender ? $(sender).closest('.modal-wrapper') : $('.modal-wrapper:visible');
	        if (typeof onlyModal == 'undefined' || !onlyModal) {
	            $('.modal-fadeout').stop().fadeOut(300);
	            if ($('#layout').data('scrollTop')) {
	                var savedScrollTop = $('#layout').data('scrollTop');
	                $('#layout').removeClass('js-modal-overflow').height('auto').removeData('scrollTop');
	                $('html,body').scrollTop(savedScrollTop);
	            }
	            $modal.stop().fadeOut(450, function () {
	                $('html').removeClass('html-modal html-modal-long');
	            });
	        } else {
	            $modal.stop().fadeOut(450);
	        }
	    },
	
	    closeModal: function closeModal(sender) {
	        var that = this;
	        if ($('.modal-wrapper:visible').length > 1) {
	            $('.modal-wrapper[data-transparent]').stop().animate({ 'opacity': 1 }, that.__animationSpeed);
	            that.hideModal(sender, true);
	        } else {
	            that.hideModal(sender, false);
	        }
	    },
	
	    showModalConfirm: function showModalConfirm(header, btn, action) {
	        var that = this;
	        if (typeof header != 'undefined' && header) $('#modal-confirm>.modal>.contents>h1').text(header);
	        if (typeof btn != 'undefined' && btn) $('#modal-confirm-action-btn').text(btn);
	        if (typeof action == 'function') {
	            $('#modal-confirm-action-btn').click(function (e) {
	                e.preventDefault();
	                e.stopPropagation();
	
	                action();
	                that.hideModal(this, $('.modal-wrapper:visible').length > 1);
	            });
	        }
	        this.showModal('modal-confirm', true);
	    },
	
	    scrollInit: function scrollInit(block) {
	        if (!$(block).data('inited')) {
	            var maxHeight = $(block).attr('data-max-height');
	            if (maxHeight < 0) maxHeight = $(block).parent().height() - Math.abs(maxHeight);
	            if (maxHeight && $(block).outerHeight() > maxHeight) {
	                $(block).css('max-height', maxHeight + 'px').jScrollPane({
	                    showArrows: false,
	                    mouseWheelSpeed: 20,
	                    autoReinitialise: true,
	                    verticalGutter: 0,
	                    verticalDragMinHeight: 36
	                });
	            }
	            $(block).data('inited', true);
	        }
	    },
	
	    fadeoutInit: function fadeoutInit(_node) {
	        var __node = $(typeof _node == 'undefined' ? 'body' : _node);
	        __node.find('.js-fadeout').each(function (i, block) {
	            if (!$(block).data('inited')) {
	                var $holder = $('<div class="fadeout-holder"></div>').insertAfter($(block));
	                $holder.html($(block));
	                $(block).data('inited', true);
	            }
	
	            if (typeof $(block).attr('data-nowrap') != 'undefined' && $(block).attr('data-nowrap') != false && $(block).attr('data-nowrap') != 'false') {
	                $(block).addClass('nowrap');
	            }
	            $(block).scrollLeft(0);
	            var w_child = 0;
	            var range = document.createRange();
	
	            $.each(block.childNodes, function (i, node) {
	                if (node.nodeType != 3) {
	                    w_child += $(node).outerWidth(true);
	                } else {
	                    if (typeof range != 'undefined') {
	                        range.selectNodeContents(node);
	                        var size = range.getClientRects();
	                        if (typeof size != 'undefined' && typeof size[0] != 'undefined' && _typeof(size[0]['width'] != 'undefined')) w_child += size[0]['width'];
	                    }
	                }
	            });
	
	            var maxWidth = $(block).attr('data-max-width');
	            var cloneWidth = $(block).attr('data-clone-width');
	            var mobileOnly = $(block).attr('data-mobile-only');
	
	            if (!mobileOnly || mobileOnly && this.__isMobileTablet) {
	                if (cloneWidth) {
	                    $(block).width($(cloneWidth).width());
	                }
	                var holderWidth = $(block).width();
	                if (w_child > holderWidth && (!maxWidth || $(window).width() <= maxWidth)) {
	                    $(block).addClass('fadeout').removeClass('nowrap').swipe({
	                        swipeStatus: function swipeStatus(event, phase, direction, distance) {
	                            var offset = distance;
	
	                            if (phase === $.fn.swipe.phases.PHASE_START) {
	                                var origPos = $(this).scrollLeft();
	                                $(this).data('origPos', origPos);
	                            } else if (phase === $.fn.swipe.phases.PHASE_MOVE) {
	                                var origPos = $(this).data('origPos');
	
	                                if (direction == 'left') {
	                                    var scroll_max = $(this).prop('scrollWidth') - $(this).width();
	                                    var scroll_value_new = origPos - 0 + offset;
	                                    $(this).scrollLeft(scroll_value_new);
	                                    if (scroll_value_new >= scroll_max) $(this).addClass('scrolled-full');else $(this).removeClass('scrolled-full');
	                                } else if (direction == 'right') {
	                                    var scroll_value_new = origPos - offset;
	                                    $(this).scrollLeft(scroll_value_new);
	                                    $(this).removeClass('scrolled-full');
	                                }
	                            } else if (phase === $.fn.swipe.phases.PHASE_CANCEL) {
	                                var origPos = $(this).data('origPos');
	                                $(this).scrollLeft(origPos);
	                            } else if (phase === $.fn.swipe.phases.PHASE_END) {
	                                $(this).data('origPos', $(this).scrollLeft());
	                            }
	                        },
	                        threshold: 70,
	                        preventDefaultEvents: false
	                    });
	                } else {
	                    $(block).removeClass('fadeout');
	                }
	            }
	        });
	    },
	
	    editableSelectReinit: function editableSelectReinit(select) {
	        if (typeof select == 'string') var $select = $('#' + select);else $select = $(select);
	
	        var id = $select.attr('id');
	        $('#' + id + '_es').remove();
	        $select.data('editable-select', false);
	        $select.editableSelect({
	            effects: 'fade',
	            source: $select.attr('source') ? $select.attr('source') : false
	        }).on('change.editable-select', function (e) {
	            var $holder = $(e.target).closest('.input-holder');
	            if ($holder.find('.es-input').val()) {
	                $(e.target).closest('.input-holder').addClass('focused');
	            } else {
	                $(e.target).closest('.input-holder').removeClass('focused');
	            }
	        });
	        $('#' + id + '_input').show();
	        return true;
	    },
	
	    getOffsetSum: function getOffsetSum(elem) {
	        var t = 0,
	            l = 0;
	        while (elem) {
	            t += t + parseFloat(elem.offsetTop);
	            l += l + parseFloat(elem.offsetLeft);
	            elem = elem.offsetParent;
	        }
	        return { top: Math.round(t), left: Math.round(l) };
	    },
	    getOffsetRect: function getOffsetRect(elem) {
	        var box = elem.getBoundingClientRect();
	        var body = document.body;
	        var docElem = document.documentElement;
	        var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
	        var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
	        var clientTop = docElem.clientTop || body.clientTop || 0;
	        var clientLeft = docElem.clientLeft || body.clientLeft || 0;
	        var t = box.top + scrollTop - clientTop;
	        var l = box.left + scrollLeft - clientLeft;
	        return { top: Math.round(t), left: Math.round(l) };
	    },
	
	    getOffset: function getOffset(elem) {
	        if (elem.getBoundingClientRect) {
	            return this.getOffsetRect(elem);
	        } else {
	            return this.getOffsetSum(elem);
	        }
	    },
	
	    // Animated scroll to target
	    _scrollTo: function _scrollTo(target, offset) {
	        var wh = $(window).height();
	        if (typeof offset == 'undefined') offset = -Math.round(wh / 2);else if (offset === false) offset = 0;
	        $('html,body').animate({
	            scrollTop: $(target).offset().top + offset
	        }, 1000);
	    },
	
	    initialize: function initialize() {
	        var that = this;
	
	        $.fn.lightTabs = function () {
	            var showTab = function showTab(tab, saveHash) {
	                ;
	                if (!$(tab).hasClass('tab-act')) {
	                    var tabs = $(tab).closest('.tabs');
	
	                    var target_id = $(tab).attr('href');
	                    var old_target_id = $(tabs).find('.tab-act').attr('href');
	                    $(target_id).show();
	                    $(old_target_id).hide();
	                    $(tabs).find('.tab-act').removeClass('tab-act');
	                    $(tab).addClass('tab-act');
	
	                    if (typeof saveHash != 'undefined' && saveHash) history.pushState(null, null, target_id);
	                }
	            };
	
	            var initTabs = function initTabs() {
	                var tabs = this;
	
	                $(tabs).find('a').each(function (i, tab) {
	                    $(tab).click(function (e) {
	                        e.preventDefault();
	
	                        showTab(this, true);
	                        that.fadeoutInit();
	
	                        return false;
	                    });
	                    if (i == 0) showTab(tab);else $($(tab).attr('href')).hide();
	                });
	
	                $(tabs).swipe({
	                    swipeStatus: function swipeStatus(event, phase, direction, distance) {
	                        var offset = distance;
	
	                        if (phase === $.fn.swipe.phases.PHASE_START) {
	                            var origPos = $(this).scrollLeft();
	                            $(this).data('origPos', origPos);
	                        } else if (phase === $.fn.swipe.phases.PHASE_MOVE) {
	                            var origPos = $(this).data('origPos');
	
	                            if (direction == 'left') {
	                                var scroll_max = $(this).prop('scrollWidth') - $(this).width();
	                                var scroll_value_new = origPos - 0 + offset;
	                                $(this).scrollLeft(scroll_value_new);
	                                if (scroll_value_new >= scroll_max) $(this).addClass('scrolled-full');else $(this).removeClass('scrolled-full');
	                            } else if (direction == 'right') {
	                                var scroll_value_new = origPos - offset;
	                                $(this).scrollLeft(scroll_value_new);
	                                $(this).removeClass('scrolled-full');
	                            }
	                        } else if (phase === $.fn.swipe.phases.PHASE_CANCEL) {
	                            var origPos = $(this).data('origPos');
	                            $(this).scrollLeft(origPos);
	                        } else if (phase === $.fn.swipe.phases.PHASE_END) {
	                            $(this).data('origPos', $(this).scrollLeft());
	                        }
	                    },
	                    threshold: 70
	                });
	            };
	
	            return this.each(initTabs);
	        };
	
	        this.initElements();
	        this.onResize();
	
	        // CHECK HASH FOR TABS
	        var url_data = this.parseUrl();
	        $('.tabs, .js-tabs').find('a').each(function (i, link) {
	            if (url_data.hash == $(link).attr('href')) {
	                $(link).click();
	            }
	        });
	
	        // BURGER
	        $('#menu-holder').click(function () {
	            if (!$('body').hasClass('mobile-opened')) {
	                if (!$(this).children('.close').data('inited')) {
	                    $(this).children('.close').click(function (e) {
	                        e.stopPropagation();
	                        $('body').removeClass('mobile-opened');
	                        $('.modal-fadeout').stop().fadeOut(300);
	                    }).data('inited', true);
	                }
	
	                $('#menu-holder').css('left', '-75%');
	                $('#bl-geo, #tel, #bl-account').hide();
	                $('body').addClass('mobile-opened');
	                $('#menu-holder').find('.close').stop().show();
	                $('#menu-holder').animate({ 'left': '0' }, that.__animationSpeed);
	                $('#bl-geo, #tel, #bl-account').stop().fadeIn(that.__animationSpeed);
	
	                /*
	                if ($(this).children('ul').outerHeight() > $(window).height()) {
	                    $('html').addClass('html-mobile-long');
	                } else {
	                    $('html').removeClass('html-mobile-long');
	                }
	                */
	
	                $('.modal-fadeout').stop().fadeIn(300);
	            }
	        });
	
	        // VISUAL VERSION
	        if ($('#visual-line').length) {
	            $('#visual-line>ul>li>ul>li').click(function (e) {
	                e.preventDefault();
	                var old = $(this).siblings('.active');
	
	                var oldClass = old.attr('data-class');
	                var newClass = $(this).attr('data-class');
	
	                $(this).addClass('active');
	                old.removeClass('active');
	
	                if (newClass) {
	                    $('body').addClass(newClass);
	                }
	                if (oldClass) {
	                    $('body').removeClass(oldClass);
	                }
	            });
	
	            $('#visual-version').click(function (e) {
	                e.preventDefault();
	
	                if ($('#visual-line').css('display') != 'block') {
	                    $('#visual-line').stop().slideDown(that.__animationSpeed);
	                } else {
	                    $('#visual-line').stop().slideUp(that.__animationSpeed);
	                }
	            });
	        }
	
	        // ACCOUNT
	        $('#bl-account .logout').click(function () {
	            that.showModal('modal-logout');
	        });
	        if ($('#bl-account .notification').length) {
	            // FIXME demo
	            setTimeout(function () {
	                $('#bl-account .notification').stop().fadeIn(that.__animationSpeed);
	            }, 1500);
	
	            $('#bl-account .notification .btn').click(function () {
	                $('#bl-account .notification').stop().fadeOut(that.__animationSpeed);
	            });
	        }
	
	        // GEO
	        $('#bl-geo .curr').click(function () {
	            that.showModal('modal-geo');
	        });
	
	        /*
	        $('#modal-geo .btn').click(function() {
	            var val = $('#modal-geo select').val();
	            // FIXME DEMO
	            $('#bl-geo .curr>span').text(val);
	          });*/
	
	        // ACTIVITIES
	        $('#activities .show-more>a').click(function (e) {
	            e.preventDefault();
	
	            $('#activities ol>li.hidden').stop().slideDown(that.__animationSpeed);
	            $(this).parent().stop().slideUp(that.__animationSpeed);
	        });
	
	        // EVENTS
	        /*$('#events table tr>td>a').click(function(e) {
	            e.preventDefault();
	            that.showModal('modal-event');
	        });*/
	
	        // APPEAL
	        $('#appeal-attachments').change(function () {
	            var $holder = $(this).closest('.file-upload');
	            var filename = $(this).val().replace(/^.*[\\\/]/, '');
	
	            if (!$holder.siblings('.files-list').length) {
	                $holder.before('<ul class="files-list"></ul>');
	            }
	            var $list = $holder.siblings('.files-list');
	            $list.append('<li class="hidden"><span class="name">' + filename + '</span><i class="remove">Удалить</i></li>');
	            $list.children('li:last').stop().slideDown(that.__animationSpeed).children('.remove').click(function () {
	                $(this).closest('li').stop().slideUp(that.__animationSpeed, function () {
	                    $(this).remove();
	                });
	                $holder.stop().fadeIn(that.__animationSpeed);
	                // FIXME
	            });
	            $holder.stop().fadeOut(that.__animationSpeed);
	            // FIXME
	        });
	        $('#appeal .form .btn-line .btn').click(function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	
	            // FIXME DEMO
	
	            // $('#appeal').stop().slideUp(that.__animationSpeed);
	            // $('#done').stop().slideDown(that.__animationSpeed);
	        });
	
	        // MY
	        var ih = 190;
	        $('#my .list>ul>li').each(function (index, li) {
	            if ($(li).children('.inner').outerHeight() > ih) {
	                $(li).children('.inner').addClass('clipped');
	            } else {
	                $(li).children('.toggler').hide();
	            }
	
	            $(li).children('.toggler').click(function () {
	                $li = $(this).closest('li');
	                $inner = $(li).children('.inner');
	                if (!$li.hasClass('opened')) {
	                    $inner.height($inner.height()).stop().animate({ height: $inner.get(0).scrollHeight }, that.__animationSpeed, function () {
	                        $(this).removeClass('clipped');
	                        $inner.height('auto');
	                    });
	                    $li.addClass('opened');
	                    $(this).text('Скрыть');
	                } else {
	                    $inner.height($inner.height()).stop().animate({ height: ih }, that.__animationSpeed, function () {
	                        $inner.addClass('clipped');
	                    });
	                    $li.removeClass('opened');
	                    $(this).text('Читать полностью');
	                }
	            });
	        });
	
	        // BROWSERS SUPPORT
	        $('#browsers-support').click(function (e) {
	            e.preventDefault();
	            that.showModal('modal-browsers-support');
	        });
	    }
	};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "logo.png?63e2e33ed47f44aa94f2260296a814c9";

/***/ }),

/***/ 6:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _pageScripts = __webpack_require__(2);
	
	var _pageScripts2 = _interopRequireDefault(_pageScripts);
	
	var _application = __webpack_require__(4);
	
	var _application2 = _interopRequireDefault(_application);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    data: function data() {
	        return {
	            props: _application2.default.props,
	            constants: _application2.default.constants,
	            newMunicipalityId: null,
	            providers: UserAPI.authProviders()
	        };
	    },
	    created: function created() {},
	
	    mounted: function mounted() {
	        var that = this;
	        this.newMunicipalityId = $("#mun_select").val();
	        setTimeout(function () {
	            $("#mun_select").selectmenu({ change: function change(event, ui) {
	                    that.newMunicipalityId = ui.item.value;
	                } });
	        }, 100);
	    },
	
	    methods: {
	        saveMunicipality: function saveMunicipality() {
	            localStorage.setItem(_application2.default.constants.LOCAL_STORAGE_MUNICIPALITY_ID, this.newMunicipalityId);
	            _application2.default.setCurrentMunicipalityName();
	            _pageScripts2.default.hideModal();
	            location.reload();
	        },
	        getEsiaUrl: function getEsiaUrl() {
	            for (var i = 0; i < this.providers.length; i++) {
	                var provider = this.providers[i];
	                if (provider.name == 'esia') {
	                    return provider.url;
	                }
	            }
	            return "";
	        }
	    }
	};

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    components: {},
	    data: function data() {
	        return {
	            props: Application.props,
	            providers: UserAPI.authProviders()
	            //                authUrl: 'http://safecity.amfitel.ru:2111/aas/oauth2/ac?response_type=code&client_id=esia&redirect_uri=http%3A%2F%2Fsafecity.amfitel.ru%2Fscy-core-web-1.0%2Fplatform%2Foauth%2FESIA'
	        };
	    },
	    created: function created() {},
	    methods: {
	        logout: function logout() {
	            UserAPI.logout(Application.onCompleteLogout);
	        },
	        getEsiaUrl: function getEsiaUrl() {
	            for (var i = 0; i < this.providers.length; i++) {
	                var provider = this.providers[i];
	                if (provider.name == 'esia') {
	                    return provider.url;
	                }
	            }
	            return "";
	        },
	
	        getMunicipality: function getMunicipality() {
	            return Application.getCurrentMunicipality();
	        }
	    }
	};

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	
	exports.default = {
	    components: {},
	
	    data: function data() {
	        return {
	            showImages: true,
	            fontColor: 'white',
	            fontSize: 'n'
	
	        };
	    },
	
	    created: function created() {
	        this.setVisuallyStyles();
	    },
	
	    methods: {
	
	        setVisuallyStyles: function setVisuallyStyles() {
	            if (localStorage.getItem("showImages") != null) {
	                if (localStorage.getItem("showImages") == 'true') {
	                    // $('body').removeClass('images-off');
	                    this.showImages = true;
	                } else {
	                    $('body').addClass('images-off');
	                    this.showImages = false;
	                }
	            }
	            if (localStorage.getItem('fontColor') != null) {
	                if (localStorage.getItem('fontColor') == 'color-bw') {
	                    $('body').addClass('color-bw');
	                    this.fontColor = 'color-bw';
	                }
	                if (localStorage.getItem('fontColor') == 'color-bg') {
	                    $('body').addClass('color-bg');
	                    this.fontColor = 'color-bg';
	                }
	            }
	
	            if (localStorage.getItem('fontSize') != null) {
	                if (localStorage.getItem('fontSize') == 'font-size-b') {
	                    $('body').addClass('font-size-b');
	                    this.fontSize = 'font-size-b';
	                }
	                if (localStorage.getItem('fontSize') == 'font-size-vb') {
	                    $('body').addClass('font-size-vb');
	                    this.fontSize = 'font-size-vb';
	                }
	            }
	        },
	
	        showImagesChange: function showImagesChange(status) {
	            localStorage.setItem("showImages", status);
	        },
	
	        setFontColorChange: function setFontColorChange(value) {
	            localStorage.setItem('fontColor', value);
	        },
	
	        setFontSizeChange: function setFontSizeChange(value) {
	            localStorage.setItem('fontSize', value);
	        }
	    }
	};

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(6),
	  /* template */
	  __webpack_require__(13),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(7),
	  /* template */
	  __webpack_require__(14),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(8),
	  /* template */
	  __webpack_require__(12),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 12:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "visual-line"
	    }
	  }, [_c('ul', {
	    staticClass: "holder"
	  }, [_c('li', [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Размер шрифта")]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "id": "visual-font-size"
	    }
	  }, [_c('li', {
	    staticClass: "n",
	    class: {
	      'active': _vm.fontSize == 'n'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFontSizeChange('n')
	      }
	    }
	  }, [_vm._v("A")]), _vm._v(" "), _c('li', {
	    staticClass: "b",
	    class: {
	      'active': _vm.fontSize == 'font-size-b'
	    },
	    attrs: {
	      "data-class": "font-size-b"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFontSizeChange('font-size-b')
	      }
	    }
	  }, [_vm._v("A")]), _vm._v(" "), _c('li', {
	    staticClass: "vb",
	    class: {
	      'active': _vm.fontSize == 'font-size-vb'
	    },
	    attrs: {
	      "data-class": "font-size-vb"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFontSizeChange('font-size-vb')
	      }
	    }
	  }, [_vm._v("A")])])]), _vm._v(" "), _c('li', [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Изображения")]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "id": "visual-images"
	    }
	  }, [_c('li', {
	    staticClass: "on",
	    class: {
	      'active': _vm.showImages
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showImagesChange(true)
	      }
	    }
	  }, [_vm._v("Вкл")]), _vm._v(" "), _c('li', {
	    staticClass: "off",
	    class: {
	      'active': !_vm.showImages
	    },
	    attrs: {
	      "data-class": "images-off"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.showImagesChange(false)
	      }
	    }
	  }, [_vm._v("Выкл")])])]), _vm._v(" "), _c('li', [_c('div', {
	    staticClass: "label"
	  }, [_vm._v("Цвет фона")]), _vm._v(" "), _c('ul', {
	    attrs: {
	      "id": "visual-color"
	    }
	  }, [_c('li', {
	    staticClass: "n",
	    class: {
	      'active': _vm.fontColor == 'white'
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFontColorChange('white')
	      }
	    }
	  }), _vm._v(" "), _c('li', {
	    staticClass: "bw",
	    class: {
	      'active': _vm.fontColor == 'color-bw'
	    },
	    attrs: {
	      "data-class": "color-bw"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFontColorChange('color-bw')
	      }
	    }
	  }), _vm._v(" "), _c('li', {
	    staticClass: "bg",
	    class: {
	      'active': _vm.fontColor == 'color-bg'
	    },
	    attrs: {
	      "data-class": "color-bg"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setFontColorChange('color-bg')
	      }
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('footer', [_c('div', {
	    staticClass: "holder"
	  }, [_c('div', {
	    staticClass: "wrap"
	  }, [_c('div', {
	    attrs: {
	      "id": "copyright"
	    }
	  }, [_vm._v("© 2019")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
	    staticClass: "btn-appeal btn",
	    attrs: {
	      "href": _vm.props.authorizedUser == null ? _vm.getEsiaUrl() : '/appeal'
	    }
	  }, [_c('span', [_vm._v("Подать обращение")])]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "/policy",
	      "id": "policy"
	    }
	  }, [_vm._v("Политика обработки персональных данных")]), _vm._v(" "), _c('a', {
	    attrs: {
	      "href": "#",
	      "id": "browsers-support"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.$('#browsers-support')
	      }
	    }
	  }, [_vm._v("Список поддерживаемых браузеров")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-fadeout"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "modal-wrapper",
	    attrs: {
	      "id": "modal-geo"
	    }
	  }, [_c('div', {
	    staticClass: "modal"
	  }, [_c('div', {
	    staticClass: "contents"
	  }, [_c('div', {
	    staticClass: "modal-close",
	    attrs: {
	      "title": "Close"
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v("Выбрать муниципальное образование")]), _vm._v(" "), _c('select', {
	    attrs: {
	      "id": "mun_select",
	      "name": "geo"
	    }
	  }, _vm._l((_vm.props.municipalities), function(municipality) {
	    return (municipality.id != _vm.constants.MUNICIPALITIES.ALL) ? _c('option', {
	      attrs: {
	        "name": municipality.name
	      },
	      domProps: {
	        "value": municipality.id,
	        "selected": municipality.id == _vm.props.municipalityId
	      }
	    }, [_vm._v(_vm._s(municipality.name))]) : _vm._e()
	  }), 0), _vm._v(" "), _c('button', {
	    staticClass: "btn type2",
	    on: {
	      "click": function($event) {
	        return _vm.saveMunicipality()
	      }
	    }
	  }, [_vm._v("Сохранить")])])])]), _vm._v(" "), _vm._m(1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "#",
	      "id": "logo-footer"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(3),
	      "alt": "Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»",
	      "title": "Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»"
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-wrapper",
	    attrs: {
	      "id": "modal-browsers-support"
	    }
	  }, [_c('div', {
	    staticClass: "modal"
	  }, [_c('div', {
	    staticClass: "contents"
	  }, [_c('div', {
	    staticClass: "modal-close",
	    attrs: {
	      "title": "Close"
	    }
	  }), _vm._v(" "), _c('h1', [_vm._v("Список поддерживаемых браузеров")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Microsoft Edge / Internet Explorer 10 и выше")]), _vm._v(" "), _c('li', [_vm._v("Mozilla Firefox 60 и выше")]), _vm._v(" "), _c('li', [_vm._v("Google Chrome 49 и выше")]), _vm._v(" "), _c('li', [_vm._v("Opera 35 и выше")]), _vm._v(" "), _c('li', [_vm._v("iOS Safari 12 и выше")])])])])])
	}]}

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', [_c('div', {
	    staticClass: "topline"
	  }, [_c('div', {
	    staticClass: "holder"
	  }, [_c('div', {
	    staticClass: "wrap"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "bl-account"
	    }
	  }, [(_vm.props.authorizedUser != null) ? _c('span', {
	    staticClass: "hello"
	  }, [_vm._v("Здравствуйте, " + _vm._s(_vm.props.authorizedUser.formattedUserName))]) : _vm._e(), _vm._v(" "), (_vm.props.authorizedUser == null) ? _c('a', {
	    staticClass: "enter",
	    attrs: {
	      "href": _vm.getEsiaUrl()
	    }
	  }, [_vm._v("Войти")]) : _c('a', {
	    staticClass: "my",
	    attrs: {
	      "href": "/appeals"
	    }
	  }, [_vm._v("Мои обращения")]), _vm._v(" "), (_vm.props.authorizedUser != null) ? _c('a', {
	    staticClass: "logout",
	    attrs: {
	      "href": "javascript:;"
	    },
	    on: {
	      "click": _vm.logout
	    }
	  }, [_vm._v("Выйти")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
	    staticClass: "holder"
	  }, [_c('div', {
	    staticClass: "wrap"
	  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('a', {
	    staticClass: "btn-appeal btn",
	    attrs: {
	      "href": _vm.props.authorizedUser == null ? _vm.getEsiaUrl() : '/appeal'
	    }
	  }, [_c('span', [_vm._v("Подать обращение")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "bl-geo"
	    }
	  }, [_vm._v("\n                    Вы находитесь: "), _c('a', {
	    staticClass: "curr",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    attrs: {
	      "id": "municipality_name_span"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "visual-version"
	    }
	  }, [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("Слабовидящим")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "/",
	      "id": "logo"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(3),
	      "alt": "Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»",
	      "title": "Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»"
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Государственная информационная система Омской области «Аппаратно-программный комплекс технических средств «Безопасный город»")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "menu-holder"
	    }
	  }, [_c('nav', {
	    attrs: {
	      "id": "menu-main"
	    }
	  }, [_c('ul', [_c('li', [_c('a', {
	    attrs: {
	      "href": "/news"
	    }
	  }, [_vm._v("Новости")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/documents"
	    }
	  }, [_vm._v("Документы")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "/contacts"
	    }
	  }, [_vm._v("Контакты ЕДДС МО")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "close"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    attrs: {
	      "href": "tel:112",
	      "id": "tel"
	    }
	  }, [_c('span', [_vm._v("Телефон вызова экстренных оперативных служб:")]), _vm._v("112")])
	}]}

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _pageScripts = __webpack_require__(2);
	
	var _pageScripts2 = _interopRequireDefault(_pageScripts);
	
	var _VHeader = __webpack_require__(10);
	
	var _VHeader2 = _interopRequireDefault(_VHeader);
	
	var _VFooter = __webpack_require__(9);
	
	var _VFooter2 = _interopRequireDefault(_VFooter);
	
	var _application = __webpack_require__(4);
	
	var _application2 = _interopRequireDefault(_application);
	
	var _VVisually = __webpack_require__(11);
	
	var _VVisually2 = _interopRequireDefault(_VVisually);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        'VVisually': _VVisually2.default,
	        'VHeader': _VHeader2.default,
	        'VFooter': _VFooter2.default
	    },
	
	    data: function data() {
	        return {
	            //canInteract: true,
	            content: null,
	            pageName: null
	        };
	    },
	
	    created: function created() {
	
	        _application2.default.process('/' + this.$route.params.id, false);
	        var element = ContentAPI.element(this.$route.params.id, false, null, null);
	        if (!element) {
	            element = ContentAPI.element("404", false, null, null);
	            this.pageName = "Ошибка";
	        } else {
	            this.pageName = element.name;
	        }
	
	        this.content = element;
	    },
	
	    mounted: function mounted() {
	        _pageScripts2.default.initialize();
	    },
	
	    methods: {}
	}; //
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//
	//

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(24),
	  /* template */
	  __webpack_require__(60),
	  /* styles */
	  null,
	  /* scopeId */
	  null,
	  /* moduleIdentifier (server only) */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 60:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "id": "layout"
	    }
	  }, [_c('VVisually'), _vm._v(" "), _c('VHeader'), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "bread-crumbs"
	    }
	  }, [_c('div', {
	    staticClass: "holder"
	  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.pageName))])])])]), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "content"
	    }
	  }, [_c('div', {
	    staticClass: "holder"
	  }, [_c('article', {
	    staticClass: "wnd",
	    attrs: {
	      "id": "message"
	    }
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.content.fields.content)
	    }
	  })])])])], 1), _vm._v(" "), _c('VFooter')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('a', {
	    attrs: {
	      "href": "/"
	    }
	  }, [_vm._v("Главная")])])
	}]}

/***/ })

});


// WEBPACK FOOTER //
// 5.build.6ad56ef71af9e9fbe48b.js